'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var polyglot = require('../utilities/polyglot').default;

var Service = require('../models/service').default;

export default Backbone.Collection.extend({

  url: '/online_bookings/ajax_services',
  model: Service,

  parse: function (response) {
    return response.data.service;
  },

  hasUncategorized: function () {
    return this.some(function (service) {
      return service.isUncategorized();
    });
  },

  getCategories: function () {
    var categories = [], ids = [];
    this.each(function (service) {
      if (!service.has('servicecategory')) return;

      var serviceCategories = service.get('servicecategory');

      var category, index;
      for (var i = 0; i < serviceCategories.length; i++) {
        category = new Backbone.Model({
          id: serviceCategories[i].id,
          name: serviceCategories[i].name,
          sort_order: serviceCategories[i].sort_order,
        });

        index = ids.indexOf(category.id);
        if (index === -1) {
          category.services = [service];
          ids.push(category.id);
          categories.push(category);
        } else {
          categories[index].services.push(service);
        }
      }
    });

    categories = new Backbone.Collection(categories);
    categories.comparator = 'sort_order';
    categories.sort();
    return categories;
  },

  hasCategories: function() {
    return this.some(function (service) {
      return !service.isUncategorized();
    });
  },

  getCategoriesWithGeneral: function() {
    var categories = [];
    var ids = [];
    var general = {
      id: 'gen',
      name: polyglot.t('queue.general'),
      services: [],
    };

    this.each(function (service) {
      if (service.isUncategorized()) {
        general.services.push(service);
      } else {
        var serviceCategories = service.get('servicecategory');

        var category;
        var index;
        for (var i = 0; i < serviceCategories.length; i++) {
          category = {
            id: serviceCategories[i].id,
            name: serviceCategories[i].name,
            sort_order: serviceCategories[i].sort_order,
          };

          index = ids.indexOf(category.id);
          if (index === -1) {
            category.services = [service];
            ids.push(category.id);
            categories.push(category);
          } else {
            categories[index].services.push(service);
          }
        }
      }
    });

    if (general.services.length) {
      general = new Backbone.Model(general);
      categories.push(general);
    }

    categories = new Backbone.Collection(categories);
    categories.comparator = 'sort_order';
    categories.sort();
    return categories;
  }

});
